import * as amplitude from '@amplitude/analytics-browser';
import { LogLevel } from '@amplitude/analytics-types';
import { ampli } from './ampli';
import { getAmplitudeApiKey } from './datalayer';
import globalVariablesPlugin from './global-variables-plugin';
import lowercasePropertiesPlugin from './lowercase-properties-plugin';
import { getAutoCaptureOptions, getCookieOptions, getTrackingOptions } from './options';
import { getFeatureToggle } from '../hn-feature-toggle';
import rateLimitPlugin from './rate-limit-plugin';
import userPropertiesPlugin from './user-properties-plugin';
import { getAmplitudeID } from '../hn-user';
import AmplitudeLogger from './logger';
/**
 * Last Amplitude hvis det ikke allerede er lastet
 */
export const safeLoadAmplitude = () => {
    if (!ampli.isLoaded) {
        ampli.load({ client: { instance: amplitude } });
    }
};
/**
 * Aktiverer webanalyse med Amplitude
 *
 * @param hasConsent - Om brukeren har gitt samtykke til webanalyse
 */
export const initAmplitude = (hasConsent) => {
    if (!getFeatureToggle('AmplitudeEnabled')) {
        return;
    }
    const autocaptureOptions = getAutoCaptureOptions();
    const cookieOptions = getCookieOptions();
    const trackingOptions = getTrackingOptions();
    const apiKey = getAmplitudeApiKey();
    const userId = getAmplitudeID();
    amplitude.add(globalVariablesPlugin);
    amplitude.add(userPropertiesPlugin);
    amplitude.add(lowercasePropertiesPlugin);
    amplitude.add(rateLimitPlugin);
    amplitude.init(apiKey, {
        serverZone: 'EU',
        autocapture: autocaptureOptions,
        cookieOptions,
        trackingOptions,
        optOut: !hasConsent,
        enableDiagnostics: false,
        userId: userId,
        logLevel: LogLevel.Warn,
        loggerProvider: new AmplitudeLogger(),
    });
    safeLoadAmplitude();
};
